import React from 'react';
import { Section, SectionSubTitle, SwiperSlide, SwiperWithNavigation } from 'common/components';
import { createElementKey } from 'utils';
import { categoryCardSlide } from './product-category-cards-styles';

export type ProductCategoryCard = {
  name: string;
  imgSrc: string;
  link: {
    href: string;
    title: string;
  };
};

type ProductCategoryCardsProps = {
  cardList: ProductCategoryCard[];
  renderCard: (card: ProductCategoryCard, position: number) => React.ReactNode;
};

export const ProductCategoryCards = ({ cardList, renderCard }: ProductCategoryCardsProps) => (
  <Section>
    <SectionSubTitle margin="l">Вам могут пригодиться</SectionSubTitle>
    <SwiperWithNavigation slidesPerView="auto" watchOverflow>
      {cardList.map((card, index: number) => (
        <SwiperSlide className={categoryCardSlide} key={createElementKey('storage-add-item', index)}>
          {renderCard(card, index)}
        </SwiperSlide>
      ))}
    </SwiperWithNavigation>
  </Section>
);
